export default __webpack_public_path__ + "static/media/2.26794833.png";